import React from 'react';

import * as S from './styles';

import logoBlu from '@/assets/logo-blu.svg';

const PaymentFooter: React.FC = () => {
  return (
    <S.Wrapper>
      <S.Container>
        <img src={logoBlu} alt="Logo da Blu" />
        <S.Copyright>{`© ${new Date().getFullYear()} Blu. Todos os direitos reservados.`}</S.Copyright>
      </S.Container>
    </S.Wrapper>
  );
};

export default PaymentFooter;
